import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { LibertyFormComponent } from './components/liberty-form/liberty-form.component';
import { LibertyService } from './liberty.service';
import { Router } from '@angular/router';
import { libertyContent } from './data/content';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-liberty-landing',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        FooterComponent,
        HeaderComponent,
        LibertyFormComponent,
    ],
    templateUrl: './liberty-landing.component.html',
    styleUrl: './liberty-landing.component.scss',
})
export class LibertyLandingComponent implements OnInit {
    selectedLanguage: any = 'en';
    closeTostr: string;
    content: any = libertyContent;

    constructor(
        private _libertyService: LibertyService,
        private _router: Router,
        private toastr: ToastrService,
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = this.readLocalStorageValue('language');
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    readLocalStorageValue(key: string) {
        let value = localStorage.getItem(key);
        return value;
    }

    sendLibertyLead(data) {
        data.orgCode = 'LIBE';
        this._libertyService.sendLibertyData(data).subscribe({
            next: (res) => {
                this._router.navigate(['/insurance/success'], {
                    queryParams: { source: 'liberty' },
                    state: { id: res?.id },
                });
            },
            error: (err) => {
                this.toastr.error(err.error.message,'Error');
            },
        });
    }
}
